export default "__VITE_ASSET__84efe2ef__"